export const TEST_ID = {
  contentHeader: 'contentHeader',
  titleTextField: 'titleTextField',
  descriptionTextField: 'descriptionTextField',
  imageHolder: 'imageHolder',
  imageUploader: 'imageUploader',
  filesUploader: 'filesUploader',
};
